import {
  CheckCircleTwoTone,
  InfoCircleTwoTone,
  WarningTwoTone,
} from "@ant-design/icons";
import { Card, Space } from "antd";
import Meta from "antd/es/card/Meta";
import "./index.scss";
import { Tooltip } from "antd";
import { useEffect, useMemo, useState } from "react";
import { Requirements } from "../../Entities/job-description.entity";
import { MatchResult } from "../../Interface/Index";
import { JobApplication } from "../../Entities/job-application.entity";
import ProfileMatcherService from "../../Services/profile.matcher.service";

interface DetailedRequirementListProps {
  requirements: Requirements[];
  appliedJob: JobApplication | null;
}

const DetailedRequirementList: React.FC<DetailedRequirementListProps> = ({
  requirements,
  appliedJob,
}) => {
  const profileMatcherService = new ProfileMatcherService();
  const [arrow, setArrow] = useState("Show");
  const [profileMatchResult, setProfileMatchResult] =
    useState<MatchResult | null>(null);

  const fetchMatchResult = async (applicationId: string) => {
    const matchResult =
      await profileMatcherService.getMatchResultByJobApplicationId(
        applicationId
      );
    setProfileMatchResult(matchResult[0]);
  };

  useEffect(() => {
    if (appliedJob) {
      fetchMatchResult(appliedJob._id);
    }
  }, [appliedJob]);

  const mergedArrow = useMemo(() => {
    if (arrow === "Hide") {
      return false;
    }

    if (arrow === "Show") {
      return true;
    }

    return {
      pointAtCenter: true,
    };
  }, [arrow]);

  function renderStatus(id: any) {
    const data = profileMatchResult?.results;
    const value = data?.find((item: any) => item?.requirement_id === id);
    if (value) {
      if (value?.match_status === 0) {
        return (
          <Tooltip
            placement="top"
            title="Sorry, your skills do not match this requirement"
            arrow={mergedArrow}
            trigger={"hover"}
          >
            <WarningTwoTone
              // twoToneColor="#ff4d4d"
              style={{ fontSize: 24, marginTop: 4 }}
            />
          </Tooltip>
        );
      } else if (value?.match_status === -1) {
        return (
          <Tooltip
            placement="top"
            title="Sufficient information was not found in the resume"
            arrow={mergedArrow}
          >
            <InfoCircleTwoTone
              // twoToneColor="#f0ad4e"
              style={{ fontSize: 24, marginTop: 4 }}
            />
          </Tooltip>
        );
      } else if (value?.match_status === 1) {
        return (
          <Tooltip
            placement="top"
            title="Your skills match this requirement"
            arrow={mergedArrow}
          >
            <CheckCircleTwoTone
              // twoToneColor="#52c41a"
              style={{ fontSize: 24, marginTop: 4 }}
            />
          </Tooltip>
        );
      }
    }
  }

  return (
    <Space direction="vertical" size="small" style={{ display: "flex" }}>
      {requirements.length > 0 &&
        requirements.map((requirement: Requirements) => (
          <Card
            key={requirement.id}
            size="small"
            type="inner"
            className="detailed_requirement_list"
            bordered={false}
          >
            <Meta
              avatar={profileMatchResult && renderStatus(requirement?.id)}
              title={
                <span className="detailed_requirement_title">
                  {requirement.topic}
                </span>
              }
              description={
                <span className="detailed_requirement_description">
                  {requirement.description}
                </span>
              }
            />
          </Card>
        ))}
    </Space>
  );
};

export default DetailedRequirementList;
